import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const PurchaseReturnsList = () => {
    const [purchaseReturns, setPurchaseReturns] = useState([]);
    const [filteredPurchaseReturns, setFilteredPurchaseReturns] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch purchase returns when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}purchasereturns`)
            .then(response => response.json())
            .then(data => {
                setPurchaseReturns(data.data);
                setFilteredPurchaseReturns(data.data); // Set initial filtered purchase returns
            })
            .catch(error => console.error('Error fetching purchase returns:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter purchase returns based on the search term
        const filtered = purchaseReturns.filter(returnItem =>
            returnItem.item_barcode.toLowerCase().includes(term.toLowerCase()) ||
            returnItem.pi_ref_no.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredPurchaseReturns(filtered);
    };

    // Navigate to the edit purchase return page
    const handleEdit = (id) => {
        navigate(`/EditPurchaseReturn/${id}`);
    };

    // Handle purchase return deletion (optional)
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this purchase return?")) {
            fetch(`${BASE_URL}purchasereturns/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        // Remove the deleted return from both lists (purchaseReturns and filteredPurchaseReturns)
                        setPurchaseReturns(purchaseReturns.filter(returnItem => returnItem.id !== id));
                        setFilteredPurchaseReturns(filteredPurchaseReturns.filter(returnItem => returnItem.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting purchase return:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Purchase Returns List</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Purchase Returns Table start */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        {/* Add more actions here if needed */}
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/AddPurchaseReturns')}>Add Purchase Return</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Item Barcode or PI Reference No.</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search by Item Barcode or PI Reference No."
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Item Barcode</th>
                                                <th>PI Ref No.</th>
                                                <th>Pack Unit</th>
                                                <th>Pack Qty</th>
                                                <th>Unit</th>
                                                <th>Quantity</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                                <th>Discount</th>
                                                <th>Tax Code</th>
                                                <th>Tax Rate</th>
                                                <th>Taxable</th>
                                                <th>Tax Amount</th>
                                                <th>Cess Rate</th>
                                                <th>Cess Amount</th>
                                                <th>MRP</th>
                                                <th>Net Rate</th>
                                                <th>Remarks</th>
                                                <th>Posting GL</th>
                                                <th>Batch No</th>
                                                <th>Mfg Date</th>
                                                <th>Exp Date</th>
                                                <th>Sale Rate</th>
                                                <th>Item Balance</th>
                                                <th>Barcode</th>
                                                <th>Line Barcode</th>
                                                <th>HSN Code</th>
                                                <th>Brand</th>
                                                <th>Created At</th>
                                                <th>Updated At</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredPurchaseReturns.map(returnItem => (
                                                <tr key={returnItem.id}>
                                                    <td>{returnItem.item_barcode || 'N/A'}</td>
                                                    <td>{returnItem.pi_ref_no || 'N/A'}</td>
                                                    <td>{returnItem.pack_unit || 'N/A'}</td>
                                                    <td>{returnItem.pack_qty || 'N/A'}</td>
                                                    <td>{returnItem.unit || 'N/A'}</td>
                                                    <td>{returnItem.quantity || 'N/A'}</td>
                                                    <td>{returnItem.rate || 'N/A'}</td>
                                                    <td>{returnItem.amount || 'N/A'}</td>
                                                    <td>{returnItem.discount || 'N/A'}</td>
                                                    <td>{returnItem.taxcode || 'N/A'}</td>
                                                    <td>{returnItem.taxrate || 'N/A'}</td>
                                                    <td>{returnItem.taxable || 'N/A'}</td>
                                                    <td>{returnItem.taxamount || 'N/A'}</td>
                                                    <td>{returnItem.cess_rate || 'N/A'}</td>
                                                    <td>{returnItem.cess_amount || 'N/A'}</td>
                                                    <td>{returnItem.mrp || 'N/A'}</td>
                                                    <td>{returnItem.net_rate || 'N/A'}</td>
                                                    <td>{returnItem.remarks || 'N/A'}</td>
                                                    <td>{returnItem.posting_gl || 'N/A'}</td>
                                                    <td>{returnItem.bd_batch_no || 'N/A'}</td>
                                                    <td>{returnItem.bd_mfg_date || 'N/A'}</td>
                                                    <td>{returnItem.bd_exp_date || 'N/A'}</td>
                                                    <td>{returnItem.bd_sale_rate || 'N/A'}</td>
                                                    <td>{returnItem.item_balance || 'N/A'}</td>
                                                    <td>{returnItem.barcode || 'N/A'}</td>
                                                    <td>{returnItem.line_level_barcode || 'N/A'}</td>
                                                    <td>{returnItem.hsn_code || 'N/A'}</td>
                                                    <td>{returnItem.brand || 'N/A'}</td>
                                                    <td>{returnItem.created_at || 'N/A'}</td>
                                                    <td>{returnItem.updated_at || 'N/A'}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(returnItem.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(returnItem.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Purchase Returns Table end */}
        </div>
    );
};

export default PurchaseReturnsList;
